// extracted by mini-css-extract-plugin
export var heading = "layout-module--heading--8VjLO";
export var poemPreview = "layout-module--poem-preview--MTZOH";
export var poemPreviewDate = "layout-module--poem-preview-date--mm93A";
export var poemPreviewLink = "layout-module--poem-preview-link--SzayE";
export var poemPreviewText = "layout-module--poem-preview-text--0s6ou";
export var poemPreviewTitle = "layout-module--poem-preview-title--ZzJP-";
export var poetryContainer = "layout-module--poetry-container--ThJuG";